import { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { useFormatDateTime } from 'shared/hooks/use-format-date-time'
import useUser, { isAuthorizedUser } from 'shared/hooks/use-user'
import { useCourseData } from 'modules/course/hooks/use-course-data'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseInfoScreenLayout } from './course-info-screen-layout'

export const CourseAccessFromScreen = (): ReactNode => {
  const { t } = useTranslation()

  const { user } = useUser()
  const { courseData } = useCourseData()
  const accessFromFormatted = useFormatDateTime(
    isAuthorizedUser(user) ? courseData?.accessFrom : null,
  )

  return (
    <CourseInfoScreenLayout
      className={addPublicCustomClassNamePrefix(`course__info-screen--course-will-be-available`)}
      text={t('course.course_will_be_available_message', {
        date: accessFromFormatted?.formatted ?? '',
      })}
    />
  )
}
